import { TFunction } from 'react-i18next';
import * as Yup from 'yup';
import { Shape } from '../yup_types';

export enum CUSTOMER_FORM_FIELDS {
	CUSTOMER_NAME = 'CustomerSupportName',
	SUPPORT_LINK = 'CustomerSupportLink',
	CUSTOMER_EMAIL = 'CustomerSupportEmail',
	CUSTOMER_PHONE = 'CustomerSupportPhone',
}

export enum CUSTOMER_FORM_FIELDS_NAMES {
	CUSTOMER_NAME = 'NEW_APPLICATION.LABEL.CUSTOMER_NAME',
	SUPPORT_LINK = 'NEW_APPLICATION.LABEL.SUPPORT_LINK',
	CUSTOMER_EMAIL = 'NEW_APPLICATION.LABEL.CUSTOMER_EMAIL',
	CUSTOMER_PHONE = 'NEW_APPLICATION.LABEL.CUSTOMER_PHONE',
	CUSTOMER_NAME_TOOLTIP = 'NEW_APPLICATION.LABEL.CUSTOMER_NAME_TOOLTIP',
	SUPPORT_LINK_TOOLTIP = 'NEW_APPLICATION.LABEL.SUPPORT_LINK_TOOLTIP',
	CUSTOMER_EMAIL_TOOLTIP = 'NEW_APPLICATION.LABEL.CUSTOMER_EMAIL_TOOLTIP',
	CUSTOMER_PHONE_TOOLTIP = 'NEW_APPLICATION.LABEL.CUSTOMER_PHONE_TOOLTIP',
}

export type CustomerFieldsTypes = {
	[CUSTOMER_FORM_FIELDS.CUSTOMER_NAME]: string;
	[CUSTOMER_FORM_FIELDS.SUPPORT_LINK]: string;
	[CUSTOMER_FORM_FIELDS.CUSTOMER_EMAIL]: string;
	[CUSTOMER_FORM_FIELDS.CUSTOMER_PHONE]: string;
};

export type CustomerFieldsReturnTypes = {
	customerSupportName: '',
	customerSupportLink: '',
	customerSupportEmail: '',
	customerSupportPhone: '',
};

// @ts-ignore
export const getCustomerValidationSchema = (t: TFunction): Yup.SchemaOf<CustomerFieldsTypes> => Yup.object<Shape<CustomerFieldsTypes>>().shape({
	[CUSTOMER_FORM_FIELDS.CUSTOMER_NAME]: Yup.string(),
		// .required(t('NEW_APPLICATION.VALIDATION.CUSTOMER_NAME_REQUIRED')),
	[CUSTOMER_FORM_FIELDS.SUPPORT_LINK]: Yup.string()
		.url(t('NEW_APPLICATION.VALIDATION.SUPPORT_LINK_FORMAT')),
		// .required(t('NEW_APPLICATION.VALIDATION.CUSTOMER_LINK_REQUIRED')),
	[CUSTOMER_FORM_FIELDS.CUSTOMER_EMAIL]: Yup.string()
		.email(t('NEW_APPLICATION.VALIDATION.EMAIL_ERROR_TEXT')),
		// .required(t('NEW_APPLICATION.VALIDATION.EMAIL_REQUIRED')),
	[CUSTOMER_FORM_FIELDS.CUSTOMER_PHONE]: Yup.number()
		.test('is-valid-phone', t('NEW_APPLICATION.VALIDATION.VALID_PHONE'), (value) => {
      if (!value) return true;
      const phoneRegex = /^[0-9]{10,15}$/;
      return phoneRegex.test(value.toString());
    })
		.typeError(t('NEW_APPLICATION.VALIDATION.NUMBER_ERROR_TEXT'))
		// .required(t('NEW_APPLICATION.VALIDATION.PHONE_REQUIRED')),
});

export const customerInitialValues: CustomerFieldsTypes = {
	[CUSTOMER_FORM_FIELDS.CUSTOMER_NAME]: '',
	[CUSTOMER_FORM_FIELDS.SUPPORT_LINK]: '',
	[CUSTOMER_FORM_FIELDS.CUSTOMER_EMAIL]: '',
	[CUSTOMER_FORM_FIELDS.CUSTOMER_PHONE]: '',
};

export const getFormattedCustomerFormFields = (formikValues): CustomerFieldsReturnTypes => ({
	customerSupportName: formikValues?.[CUSTOMER_FORM_FIELDS.CUSTOMER_NAME],
	customerSupportLink: formikValues?.[CUSTOMER_FORM_FIELDS.SUPPORT_LINK],
	customerSupportEmail: formikValues?.[CUSTOMER_FORM_FIELDS.CUSTOMER_EMAIL],
	customerSupportPhone: formikValues?.[CUSTOMER_FORM_FIELDS.CUSTOMER_PHONE],
});

export const convertCustomerFieldsToInitial = (data): CustomerFieldsTypes => ({
	[CUSTOMER_FORM_FIELDS.CUSTOMER_NAME]: data?.customerSupportInformation?.customerSupportName ? data?.customerSupportInformation?.customerSupportName : '',
	[CUSTOMER_FORM_FIELDS.SUPPORT_LINK]: data?.customerSupportInformation?.customerSupportLink ? data?.customerSupportInformation?.customerSupportLink : '',
	[CUSTOMER_FORM_FIELDS.CUSTOMER_EMAIL]: data?.customerSupportInformation?.customerSupportEmail ? data?.customerSupportInformation?.customerSupportEmail : '',
	[CUSTOMER_FORM_FIELDS.CUSTOMER_PHONE]: data?.customerSupportInformation?.customerSupportPhone ? data?.customerSupportInformation?.customerSupportPhone : '',
});

export const getFormattedCustomerData = (data): CustomerFieldsReturnTypes => ({
	customerSupportName: data?.customerSupportInformation?.customerSupportName,
	customerSupportLink: data?.customerSupportInformation?.customerSupportLink,
	customerSupportEmail: data?.customerSupportInformation?.customerSupportEmail ,
	customerSupportPhone: data?.customerSupportInformation?.customerSupportPhone
});
